import styled from 'styled-components';

const Headline = styled.div`
  font-size: 18px;
  color: #2e4964;
  font-weight: 700;
  margin-bottom: 10px;
`;

export default Headline;
